export default "__VITE_ASSET__ng_z35HH__"